

import { notification, Spin } from 'antd';
import React, { useEffect, useState } from 'react';

import RecentlyUpdatedBlogs from './RecentlyUpdatedBlogs';

const validateEmail = ({ email }) => {
  const re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  return re.test(String(email).toLowerCase());
};

const NewsDetails = (props) => {
  const { history, blogLinks, match, subscribeLoading, loading, loadingForRecentlyUpdatedBlogs, subscribe, getRecentlyUpdatedBlogs, getPeopleNeededForHelp, getBlogLinks, getBlogDetails, recentlyUpdatedBlogs, numberOfPeople, blogDetails } = props;
  const { 
    id, 
    image,
    image2,
    posted_by: postedBy, 
    video_url, 
    title, 
    short,
    text1,
    text2,
    text3,
    text4,
    text5,
    text6,
    text7,
    li1,
    li2,
    li3,
    li4,
    li5,
    li6
  } = blogDetails || {};
  const [appUrl] = window.location.href.split('blog-details');
  const { data } = recentlyUpdatedBlogs || {};
  const [blogAuthor] = postedBy || [];
  
  const { story, first_name: firstName, last_name: lastName, avatar } = blogAuthor || {};
  const authorPhoto = avatar ? `${process.env.REACT_APP_BACKEND_BASE_URL}/${avatar}` : '/images/team_2.png';

  let lastBlogImage = '/images/blog-img2.PNG';
  let firstBlogImage = '/images/blog.PNG';
  if (image2) {
    lastBlogImage = `${process.env.REACT_APP_BACKEND_BASE_URL}/${image2}`;
  }
  if (image) {
    firstBlogImage = `${process.env.REACT_APP_BACKEND_BASE_URL}/${image}`;
  }

  let formattedVideoUrl = video_url || 'https://www.youtube.com/embed/j7KKZ6v5o34';
  if (video_url) {
    const [firstUrlPart, secondUrlPart] = formattedVideoUrl.split('watch?v=');
    formattedVideoUrl = `${firstUrlPart}embed/${secondUrlPart}`;
  }
  const { params } = match || {};
  const blogId = params && params.id ? Number(params.id) : null;
  const [email, setEmail] = useState('');
  const isValidEmail = validateEmail({ email });
  
  useEffect(() => {
    if (blogId) {
      getPeopleNeededForHelp();
      getBlogDetails(blogId);
      getBlogLinks({ blogId });
    } else {
      notification.error({
        message: 'GET BLOG DETAILS',
        description: 'BlogID is not valid'
      })
    }
    getRecentlyUpdatedBlogs();
  }, []); // eslint-disable-line react-hooks/exhaustive-deps
  return (
    <div>
      <section className="banner event blog-det-banner">
        <div className="container">
          <div className="row  ">
            <div className="col-lg-6 col-md-6 col-sm-12">
              {/* <h1>Advanced event management and listing system.</h1>
              <p className="">The iCause event manager makes planning your event easier – manage registration, communications, merchandise and donations in one simple platform.</p>
              <button onClick={() => history.push('/choice-three')} type="button" className="btn btn-success btn_hover">Start fundraising</button> */}
            </div>
          </div>
        </div>
      </section>
      <Spin spinning={loading}>
        <section className="blog-datil blog-det-2">
          <div className="container">
            <div className="row ">
              <div className="col-lg-8 col-md-8 col-sm-12 iCause-Partners">
                <div className="box-card">
                  {
                    title ? 
                    <h1>{title}</h1> : 
                    <h1>How to travel the world and get big companies to pay for it</h1>
                  }
                  {
                    short ? 
                    <div dangerouslySetInnerHTML={{ __html: short || '' }}></div> :
                    <p>More off this less hello salamander lied porpoise much over tightly circa horse taped so innocuously outside crud mightily rigorous…</p>
                  }
                </div>
                <p className="">
                  {text1 || 'Lorem ipsum dolor sit amet, consectetuer adipiscing elit, sed diam nonummy nibh euismod tincidunt ut laoreet dolore magna aliquam erat volutpat. Ut wisi enim ad minim veniam, quis nostrud exerci tation ullamcorper suscipit obortis nisl ut aliquip ex ea commodo consequat.'}
                </p>
                <p className="">
                  {text2 || 'Duis autem vel eum iriure dolor in hendrerit in vulputate velit esse molestie consequat, vel illum dolore eu feugiat nulla facilisis at vero eros et accumsan et iusto odio dignissim qui blandit praesent luptatum zzril delenit augue duis dolore te feugait nulla facilisi. Nam liber tempor cum soluta nobis eleifend option congue nihil imperdiet doming id quod mazim placerat facer possim assum. Typi non habent claritatem insitam est usus legentis in iis'}
                </p>
                <div className="box-text">
                  <p className="font-italic" style={{ paddingTop: '10px' }}>
                    {text3 || 'Knicker lining concealed back zip fasten swing style high waisted double layer full pattern floral.'}
                  </p>
                </div>
                <p>
                  {text4 || 'Lorem ipsum dolor sit amet, consectetuer adipiscing elit, sed diam nonummy nibh euismod tincidunt ut laoreet dolore magna aliquam erat volutpat. Ut wisi enim ad minim veniam, quis nostrud exerci tation ullamcorper suscipit obortis nisl ut aliquip ex ea commodo consequat.'}
                </p>
                <iframe
                  title={id}
                  width="100%"
                  height="315"
                  src={formattedVideoUrl}
                  frameBorder="0"
                  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                  allowFullScreen>
                </iframe>
                <ul className="mt-3">
                  <li>{li1 || 'Duis autem vel eum iriure dolor in hendrerit.'}</li>
                  <li>{li2 || 'Vulputate velit esse molestie consequat.'}</li>
                  <li>{li3 || 'Nulla facilisis at vero eros et accumsan et iusto odio dignissim qui blandit.'}</li>
                </ul>
                <p className="my-3">
                  {text5 || 'Lorem ipsum dolor sit amet, consectetuer adipiscing elit, sed diam nonummy nibh euismod tincidunt ut laoreet dolore magna aliquam erat volutpat. Ut wisi enim ad minim veniam, quis nostrud exerci tation ullamcorper suscipit obortis nisl ut aliquip ex ea commodo consequat.'}
                </p>
                  <img src={firstBlogImage} className="img-fluid w-100 my-3" alt="" />
                <p className="mt-3">
                  {text6 || 'Duis autem vel eum iriure dolor in hendrerit in vulputate velit esse molestie consequat, vel illum dolore eu feugiat nulla facilisis at vero eros et accumsan et iusto odio dignissim qui blandit praesent luptatum zzril delenit augue duis dolore te feugait nulla facilisi. Nam liber tempor cum soluta nobis eleifend option congue nihil imperdiet doming id quod mazim placerat facer possim assum. Typi non habent claritatem insitam est usus legentis in iis'}
                </p>
                <div className="box-text border-left pl-4">
                  <p className="font-italic pl-0 mb-0">
                    {text7 || 'Knicker lining concealed back zip fasten swing style high waisted double layer full pattern floral.'}
                  </p>
                </div>
                <ul className="mt-3">
                  <li>{li4 || 'Duis autem vel eum iriure dolor in hendrerit.'}</li>
                  <li>{li5 || 'Vulputate velit esse molestie consequat.'}</li>
                  <li>{li6 || 'Nulla facilisis at vero eros et accumsan et iusto odio dignissim qui blandit.'}</li>
                </ul>
                <img src={lastBlogImage} className="img-fluid w-100 my-3" alt="" />
              </div>
              <div className="col-lg-4 col-md-4 col-sm-12">
                <div className="need-our-one need-our-bg blog-sec-2-img">
                  <div>
                    <h4>{numberOfPeople} Peoples<span className="d-block  "> Need Ours Help</span></h4>
                    <button onClick={() => history.push('/starting_fund')} type="button" className="btn btn-success  ml-2 btn_hover">Start fundraising</button>
                  </div>
                </div>
                <div className="subscribe mt-5">
                  <h5>Subscribe for Our News Letter!</h5>
                  <p>By subscribing you agree to receive special news and related offers from iCasue.</p>
                  <input value={email} type="email" onChange={({ target }) => setEmail(target.value)} name="" className="form-control mt-4" placeholder="You@example.com" />
                  <Spin spinning={subscribeLoading}>
                    <button 
                      onClick={() => {
                        subscribe({ email }).then(() => setEmail(''));
                      }}
                      type="button" 
                      disabled={!isValidEmail} 
                      className="btn btn-success" 
                      style={{ marginTop: 5 }}>
                        subscribe
                    </button>
                  </Spin>
                </div>
                <h6 className="mt-5">Get Connect with us and help them...</h6>

                {
                  blogLinks && blogLinks.link_title &&
                  <ul className="iCause-Partners-2">
                    <li><a href={blogLinks.site_link} title="" className="text-dark">{blogLinks.link_title}<i className="fa fa-arrow-right ml-4"></i></a></li>
                  </ul>
                }


                <div className="card card-profile text-center p-4 mt-5">
                  <div className="img-wraper">
                    <img src={authorPhoto} className="img-fluid" alt="" />
                  </div>
                  <p>POSTED BY</p>
                    {
                      firstName ?
                      <h4>{`${firstName || ''} ${lastName || ''}`}</h4> :
                      <h4>Mark Thomson</h4>
                    }
                  <p>{story}</p>
                  <div className="banner-content ">
                    <ul>
                      <li
                        onClick={() => {
                          const pageUrl = 'https://www.facebook.com/sharer/sharer.php?u=' + appUrl + `blog-details/${id}`;
                          window.open(pageUrl, '_blank');
                        }}
                      >
                        <i className="fa fa-facebook"></i>
                      </li>
                      <li
                      onClick={() => {
                        const pageUrl = 'https://www.linkedin.com/sharing/share-offsite/?url=' + appUrl + `blog-details/${id}`;
                        window.open(pageUrl, '_blank');
                      }}
                      >
                        <i className="fa fa-linkedin"></i>
                      </li>
                      <li onClick={() => {
                        const pageUrl = 'http://www.twitter.com/share?url=' + appUrl + `blog-details/${id}`;
                        window.open(pageUrl, '_blank');
                      }}>
                          <i className="fa fa-twitter"></i>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </Spin>
      <RecentlyUpdatedBlogs
        getBlogDetails={getBlogDetails}
        data={data}
        history={history}
        loading={loadingForRecentlyUpdatedBlogs}
      />
    </div>
  );
}

export default NewsDetails;
